module.exports = __webpack_public_path__ + "static/media/user-edit.7124c038.svg";